import { ApplicationSettingsQueryString } from "../../models/ApplicationSettings/ApplicationSettings";

export const ApplicationSettingsQueryKeys = {
  byAppOrAppRegId: (ids: ApplicationSettingsQueryString) => [
    "applicationSettings",
    ids,
  ],
};
